module.exports = __webpack_public_path__ + "fa-regular-400.eot?b0e2db3b634d1bc3928e127458d993d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-regular-400.eot
// module id = 327
// module chunks = 0